import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import type TeamConversationModel from 'uplisting-frontend/models/team-conversation';
import type TeamMentionModel from 'uplisting-frontend/models/team-mention';

const REMOVAL_WINDOW_MS = 5 * 60 * 1000;

export default class TeamMessageModel extends Model {
  @attr('string') body!: string;
  @attr('date') editedAt?: Date | null;
  @attr('date') deletedAt?: Date | null;
  @attr('boolean') deleted!: boolean;
  @attr('date') createdAt!: Date;
  @attr('boolean') system!: boolean;
  @attr('string') authorUserId?: string | null;
  @attr('string') authorName?: string | null;
  @attr('boolean') own!: boolean;

  @attr('string') resourceType?: string;
  @attr('string') resourceId?: string;

  @belongsTo('team-conversation', { async: false, inverse: null })
  teamConversation?: TeamConversationModel | null;

  @hasMany('team-mention', { async: false, inverse: 'teamMessage' })
  teamMentions!: TeamMentionModel[];

  get isEdited(): boolean {
    return Boolean(this.editedAt);
  }

  get isRemoved(): boolean {
    return this.deleted || Boolean(this.deletedAt);
  }

  get isRemovable(): boolean {
    return (
      this.own &&
      !this.isRemoved &&
      Date.now() - this.createdAt.getTime() <= REMOVAL_WINDOW_MS
    );
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'team-message': TeamMessageModel;
  }
}
